import { useState } from "react";
import type { PlaceAction } from "../types";
import ConfirmRemove from "./ConfirmRemove";
import { SelectField } from "./fields";

type Props = {
  actions: PlaceAction[];
  types: Record<string, string>;
  busy: boolean;
  onAdd: (type: string, uri: string) => Promise<void>;
  onDelete: (name: string) => void;
};

export default function ActionsPanel({ actions, types, busy, onAdd, onDelete }: Props) {
  const [type, setType] = useState("APPOINTMENT");
  const [uri, setUri] = useState("");

  return (
    <div>
      <h3 className="text-lg font-semibold">Actions</h3>
      <p className="mt-1 text-sm text-slate-500">Les boutons Réserver ou Commander sur Google.</p>
      <ul className="mt-6 space-y-2">
        {actions.map((a) => (
          <li key={a.name} className="flex items-center justify-between gap-3 rounded-2xl bg-mist px-4 py-3">
            <span className="truncate text-sm">
              <span className="font-medium">{types[a.type] || a.type}</span>
              <span className="ml-2 text-slate-500">{a.uri}</span>
            </span>
            <ConfirmRemove question="Retirer ce lien ?" onConfirm={() => onDelete(a.name)} />
          </li>
        ))}
      </ul>
      <form
        className="mt-5 flex flex-wrap gap-2"
        onSubmit={(e) => {
          e.preventDefault();
          void onAdd(type, uri).then(() => setUri(""));
        }}
      >
        <div className="min-w-[220px] flex-1">
          <SelectField
            value={type}
            onChange={setType}
            options={Object.entries(types).map(([id, label]) => ({ value: id, label }))}
          />
        </div>
        <input value={uri} onChange={(e) => setUri(e.target.value)} placeholder="https://…" className="pr-input min-w-[200px] flex-1" />
        <button type="submit" disabled={busy} className="pr-btn">
          Ajouter
        </button>
      </form>
    </div>
  );
}
